// Matches the id HelpPage.jsx's markdown renderer derives for every h2/h3 heading —
// keep both in sync so anchor links built from this always resolve.
export const slugify = (text) =>
  String(text)
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
